import * as Models from "../ts/rlAdmin.models";
import * as Consts from "../ts/rlAdmin.consts";
import * as Utils from "../ts/rlAdmin.utils";

import * as _ from "lodash";
import * as angular from "angular";
import { BaseContractController } from "../controllers/_baseDealController";
import { ContractService } from "../services/contract-service";
import { LocalCacheService } from "../services/local-cache-service";
import { NotifyService } from "../services/notify-service";
import { EntityService } from "../services/entity-service";
import { ContractSharedDataService } from "../services/contract-shared-data-service";
import { EventService } from "../services/event-service";
import { JobService } from "../services/job-service";
import { AdminService } from "../services/admin-service";
import { AclService } from "../services/acl-service";
import { EntityConfigService } from "../services/entity-config-service";
import { DocumentEntityService } from "../services/document-entity-service";
import { SearchService } from "../services/search-service";
import { BaseEntityAssociationController, RecordDetailController } from "./rlAdmin.controllers";
import { IRLFilepickerScope } from "./rlAdmin.directives";
import { DocGenService } from "../services/doc-gen-service";
import { ContactService } from "../services/contact-service";

export class ContractInventoryController extends BaseContractController {
	static $inject = ["$scope", "$rootScope", "$q", "$window",
		"contractService", "localCacheService", "notifyService", "entityService",
		"contractSharedDataService", "eventService", "jobService",
		"adminService", "$interval", "aclService", "entityConfigService", "$location", "$anchorScroll"];

	contractID: string;
	visibility: number;
	initialized: boolean;
	inventoryItems: Models.IRecordRelationshipPair[];
	jobs: Models.ITransactionJobRelationshipPair[];
	selectedInventoryItems: Models.IContractAssetRelationshipPair[];

	newJobModalOpen: boolean;
	newJobCharData: Models.ICharDataCollection;

	addInventoryModalOpen: boolean;
	inventoryTemplateGroupIDs: number[];

	selectedSearchInventoryIDs: number[];
	selectedSearchInventories: { [key: number]: boolean };                       // dictionary of selected Inventories from Inventory search modal
	groupCollapsed: { [groupID: string]: boolean };

	canEdit: boolean;

	jobTemplates: Models.ICharacteristicTemplate[];
	selectedJobTemplate: string;
	canCopy: boolean;
    locked: boolean;

	constructor($scope: ng.IScope,
		private $rootScope: ng.IRootScopeService,
		$q: ng.IQService,
		private $window: ng.IWindowService,
		private contractService: ContractService,
		protected localStorage: LocalCacheService,
		notifyService: NotifyService,
		entityService: EntityService,
		sharedData: ContractSharedDataService,
		private eventService: EventService,
		private jobService: JobService,
		adminService: AdminService,
		$interval: ng.IIntervalService,
		private aclService: AclService,
		private entityConfigService: EntityConfigService,
		public $location: ng.ILocationService,
		public $anchorScroll: ng.IAnchorScrollService
	) {

		super($scope, entityService, sharedData, localStorage, notifyService, adminService, $interval, $q, $location, $anchorScroll);

		this.contractID = "";
		this.visibility = 1;
		this.initialized = false;
		this.inventoryItems = [];
		this.selectedInventoryItems = [];

		this.newJobModalOpen = false;
		this.newJobCharData = null;
		this.jobs = [];

		this.addInventoryModalOpen = false;
		this.inventoryTemplateGroupIDs = [Consts.TemplateGroupIDs.InventoryItemTemplateGroup];
		this.selectedSearchInventoryIDs = [];
		this.selectedSearchInventories = {};
		this.groupCollapsed = {};

		this.canEdit = false;

		this.jobTemplates = [];
		this.selectedJobTemplate = "";
		this.canCopy = false;
        this.locked = false;
		$scope.$watch(() => this.selectedSearchInventories, (newValue: { [key: string]: boolean }) => {
			this.selectedSearchInventoryIDs = _(newValue)
				.pairs()
				.filter((pair) => pair[1] == true)
				.map((pair) => _.parseInt(<string>pair[0]))
				.valueOf();
		}, true);

		$scope.$watch(() => this.newJobModalOpen,
			(newValue, oldValue) => {
				if (!newValue && oldValue) {
					this.newJobCharData = null;
				}
			});

		// clear selected assets whenever asset search modal is closed
		$scope.$watch(() => this.addInventoryModalOpen, (newValue: boolean, oldValue: boolean) => {
			if (!newValue && oldValue) {
				this.selectedSearchInventories = {};
			}
		}, true);

		$scope.$watch(() => this.progressStatus, (newValue, oldValue) => {
			if (newValue != oldValue && newValue == "Done") {
				this.RefreshAll();
			}
		});

	}

	Init(contractID: string) {
        this.contractID = contractID;

        this.RefreshAll();
		this.LoadJobTemplates();
	}

	LoadJobTemplates() {
		this.entityConfigService.getCharacteristicTemplates(Consts.CharTypeIDs.job)
			.then((result) => {
				this.jobTemplates = result.filter(ct => Utils.AclUtil.hasCreateAccess(this.aclService.acls, ct.acl));
			});
	}

	RefreshAll(): ng.IPromise<any> {
		return this.$q.all([this.RefreshInventory(), this.RefreshJob(), this.sharedData.RefreshContract(this.contractID)])
			.then(() => {
				this.selectedInventoryItems = [];
				if (this.sharedData.contract.charDataCollection != null) {
					if (this.sharedData.contract.charDataCollection.status.lockIndicator == 0) {
						this.locked = false;
					}
					else {
						this.locked = true;
					}
                }

                //Get ACLs for user
                this.entityService.getEntityRecord(this.contractID)
                    .then((result) => {
                        var targetACL = Utils.AclUtil.getDataEntityAcl(result.charTypeID, result.templateGroupID, result.templateID);
                        this.canEdit = Utils.AclUtil.hasWriteAccess(this.aclService.acls, targetACL);
                        this.canCopy = this.canEdit;
                    });
			}).then(() => {
				this.RefreshValidation();
			})
			.finally(() => {
				this.initialized = true;
			});
	}

	RefreshValidation(): ng.IPromise<any> {
		return this.eventService.call(Consts.Events.ValidateEntity);
	}

	RefreshJob(): ng.IPromise<any> {
		this.notifyService.startProgress();
		this.jobs = [];
		//first get WOs
		return this.entityService.getRelatedEntities(this.contractID, Consts.CharTypeIDs.job)
			.then((result) => {
				var promises = [];
				_.forEach(result, (r) => {

					if (!_.isNull(r.record)) {
						var wo: Models.ITransactionJobRelationshipPair = {
							charDataCollection: r.charDataCollection,
							inventoryItems: null,
							record: r.record,
							relationship: r.relationship
						};

						var id = Utils.IdBuilder.buildEntityID(wo.record.divisionID, wo.record.charTypeID, wo.record.recordID);
						//then get inventory items for each wo
						var promise = this.entityService.getRelatedEntities(id, Consts.CharTypeIDs.property)
							.then((invResult) => {
								wo.inventoryItems = invResult;
								this.jobs.push(wo);
							});
						promises.push(promise);
					}
				});
				return this.$q.all(promises);

			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	FilterInventoryItems() {
		_.forEach(this.jobs, (wo) => {
			_.forEach(wo.inventoryItems, (inv) => {
				var item = _.find(this.inventoryItems, (x) => { return x.record.recordID == inv.record.recordID; });
				if (!_.isNull(item)) {
					if (_.contains(this.inventoryItems, item)) {
						this.inventoryItems = _.without(this.inventoryItems, item);
					}
				}
			});
		});
		this.initialized = true;
	}

	RefreshInventory(): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.contractService.getContractInventory(this.contractID)
			.then((result) => {
				this.inventoryItems = result;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	NewJob(templateID: number) {
		this.notifyService.startProgress();

		this.selectedJobTemplate = this.GetJobTemplate(templateID);

		this.entityService.getEmptyEntityCharData(this.selectedJobTemplate)
			.then((result) => {
				console.log(result);
				this.newJobCharData = result;
				this.newJobModalOpen = true;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	GetJobTemplate(id: number) {
		var contractEntityID = Utils.IdBuilder.splitEntityID(this.contractID);
		var templateID = Utils.IdBuilder.buildTemplateID(contractEntityID.divID, Consts.CharTypeIDs.job, id);
		return templateID;
	}

	CreateJob(isValid: boolean) {
		if (isValid) {

			this.notifyService.startProgress();
			this.entityService.createEntity(this.selectedJobTemplate, this.contractID, this.newJobCharData.charDatas)
				.then((result) => {
					var jobEntityID = result.entityID;
					var inventoryAssetIDs = this.selectedInventoryItems.map((inv) => inv.record.recordID);
					return this.jobService.addJobInventory(jobEntityID, inventoryAssetIDs);
				}, () => {
					this.notifyService.notifyError("Error Creating Job");
				})
				.then(() => {
					this.notifyService.notifySuccess("Job Created");
					return this.RefreshAll();
				}, angular.noop)
				.then(() => {
					this.newJobModalOpen = false;
				}, angular.noop)
				.finally(() => {
					this.notifyService.endProgress();
				});
		} else {
			this.notifyService.broadcastDone();
		}
	}

	SearchInventory() {
		this.addInventoryModalOpen = true;
		this.notifyService.broadcastDone();
	}

	AddInventories() {
		// get selected ids
		var inventoryIDs = this.selectedSearchInventoryIDs;
		if (inventoryIDs.length > 0) {
			// start progress bar
			this.notifyService.startProgress();

			// make rest call
			this.contractService.addContractInventories(this.contractID, inventoryIDs)
				.then((result) => {
					this.progressJobID = result.jobID;
					this.jobTitle = "Adding Inventory";
					this.showJobProgressStatus = true;
					this.addInventoryModalOpen = false;
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		} else {
			// notify no selected assets
			this.notifyService.notifyError("No inventory items were selected");
		}
	}

	RemoveInventory(asset: Models.IContractAssetRelationshipPair) {
		if (this.$window.confirm("Are you sure?")) {
			// start progress bar
			this.notifyService.startProgress();

			// call web api to remove assets
			this.contractService.removeContractInventory(this.contractID, asset.relationship.relRecID)
				.then((result) => {
					// notify success
					this.notifyService.notifySuccess("Inventory Removed");
					// wait for refresh of assets
					return this.RefreshAll();
				})
				.finally(() => {
					// end progress bar
					this.notifyService.endProgress();
				});
		} else {
			this.$scope.$broadcast(Consts.Events.NotifyDone);
		}
	}

	Delete() {
		if (this.$window.confirm("Are you sure you want to delete this Deal?") && this.$window.confirm("Are you REALLY SURE you want to delete this Deal?")) {
			this.notifyService.startProgress();
			this.entityService.deleteEntity(this.contractID)
				.then(() => {
					this.$window.location.assign(Consts.Urls.ContractListPage);
				},
				() => {
					this.notifyService.notifyError("Error Deleting Deal");
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		} else {
			this.$scope.$broadcast(Consts.Events.NotifyDone);
		}
	}

	ToggleAddInventory() {
		this.addInventoryModalOpen = !this.addInventoryModalOpen;
	}

	ToggleOpen(groupID: string) {
		this.groupCollapsed[groupID] = !this.groupCollapsed[groupID];
	}

	CopySuccessful(newEntityID: string) {
		//copy succeeded, navigate user to new entity
		this.$window.location.assign("/Go/" + newEntityID);
	}

	PreviewEntity(entityID: string) {
		this.selectedEntityID = entityID;
		this.$rootScope.$broadcast(Consts.Events.ViewEntity, entityID);
	}
}

export class ContractDocumentsController extends BaseContractController {
	static $inject = ["$scope", "$sce", "$q", "$window", "contractService",
		"documentEntityService", "contractSharedDataService", "localCacheService", "notifyService", "eventService", "entityService",
		"adminService", "$interval", "$location", "$anchorScroll", "aclService"];

	contractID: string;
	visibility: number;
	initialized: boolean;
	docsInitialized: boolean;
	locked: boolean;
	editDocumentID: string;
	canCopy: boolean;

	constructor($scope: ng.IScope,
		private $sce: ng.ISCEService,
		$q: ng.IQService,
		private $window: ng.IWindowService,
		private contractService: ContractService,
		private documentEntityService: DocumentEntityService,
		sharedData: ContractSharedDataService,
		localStorage: LocalCacheService,
		notifyService: NotifyService,
		private eventService: EventService,
		entityService: EntityService,
		adminService: AdminService,
		$interval: ng.IIntervalService,
		public $location: ng.ILocationService,
		public $anchorScroll: ng.IAnchorScrollService,
		private aclService: AclService) {

		super($scope, entityService, sharedData, localStorage, notifyService, adminService, $interval, $q, $location, $anchorScroll);

		this.contractID = "";
		this.visibility = 1;
		this.initialized = false;
		this.docsInitialized = true;
		this.editDocumentID = null;
		this.locked = false;
		this.canCopy = false;

		$scope.$watch(() => this.sharedData.contract != null ? this.sharedData.contract.charDataCollection.status.lockIndicator : 1,
			(newValue, oldValue) => {
				this.locked = newValue > 0;
			});

		$scope.$watch(() => {
			if (this.contractID == null) {
				return null;
			} else {
				return this.contractID;
			}
		},
			(newValue, oldValue) => {
				if (newValue != null) {
					this.eventService.on(Consts.Events.WorkflowExecuted + newValue, () => {
						this.sharedData.RefreshContract(this.contractID);
					});
				}
			});
	}

	Init(contractID: string) {
		this.contractID = contractID;
		this.aclService.loadActivityAcls()
			.then((acls) => {
				this.canCopy = Utils.AclUtil.hasCreateAccess(acls, Consts.Acl.Activities._Site.Mod4);
			});

		this.notifyService.startProgress();
		this.sharedData.RefreshContract(this.contractID)
			.then(() => {
				this.initialized = true;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	Delete() {
		if (this.$window.confirm("Are you sure you want to delete this Deal?") && this.$window.confirm("Are you REALLY SURE you want to delete this Deal?")) {
			this.notifyService.startProgress();
			this.entityService.deleteEntity(this.contractID)
				.then(() => {
					this.$window.location.assign(Consts.Urls.ContractListPage);
				},
				() => {
					this.notifyService.notifyError("Error Deleting Deal");
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		} else {
			this.$scope.$broadcast(Consts.Events.NotifyDone);
		}
	}

	RefreshAll(): ng.IPromise<any> {
		return this.RefreshValidation()
			.then(() => {
				this.docsInitialized = false;
			});
	}

	RefreshValidation(): ng.IPromise<any> {
		return this.eventService.call(Consts.Events.ValidateEntity);
	}

	CopySuccessful(newEntityID: string) {
		//copy succeeded, navigate user to new entity
		this.$window.location.assign("/Go/" + newEntityID);
	}
}

export class ContractFinancialsController extends BaseContractController {
    static $inject = ["$scope", "$rootScope", "contractService", "contractSharedDataService", "localCacheService", "notifyService",
        "$window", "entityService", "adminService", "$interval", "$q", "$location", "$anchorScroll", "aclService", "eventService"];

	contractID: string;
	visibility: number;
    initialized: boolean;
    financialItemRows: Models.IFinancialSearchDoc[];
    financialItemRowsDisplay: Models.IFinancialSearchDoc[];
	canCopy: boolean;
	locked: boolean;	


    amountPage: number;
    amountPageCount: number;
    amountNumFound: number;
    amountRowCount: number;

	constructor($scope: ng.IScope,
		private $rootScope: ng.IRootScopeService,
		private contractService: ContractService,
		sharedData: ContractSharedDataService,
		localStorage: LocalCacheService,
		notifyService: NotifyService,
		private $window: ng.IWindowService,
		entityService: EntityService,
		adminService: AdminService,
		$interval: ng.IIntervalService,
		$q: ng.IQService,
		public $location: ng.ILocationService,
		public $anchorScroll: ng.IAnchorScrollService,
		private aclService: AclService,
        private eventService: EventService) {

		super($scope, entityService, sharedData, localStorage, notifyService, adminService, $interval, $q, $location, $anchorScroll);

		this.contractID = "";
		this.visibility = 1;
		this.initialized = false;
        this.financialItemRows = [];
        this.financialItemRowsDisplay = [];        
		this.canCopy = false;
        this.locked = false;

        this.amountRowCount = 10;
        this.amountPage = 1;

		this.$scope.$on(Consts.Events.ViewEntity, (e, data) => {
			if (!_.isEmpty(data)) {
				this.ViewEntity(data);
			}
        });
        $scope.$watch(() => this.amountPage, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.UpdateFinancialsDisplay();
            }
        });

        $scope.$watch(() => this.amountRowCount, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.UpdateFinancialsDisplay();
            }
        });
		this.$scope.$watch(() => {
			if (this.contractID == null) {
				return null;
			} else {
				return this.contractID;
			}
		},
			(newValue, oldValue) => {
				if (newValue != null) {
					this.eventService.on(Consts.Events.WorkflowExecuted + newValue, () => {
						this.RefreshContract();
					});
				}
			});
	}

	Init(contractID: string) {
		this.contractID = contractID;
		this.aclService.loadActivityAcls()
			.then((acls) => {
				this.canCopy = Utils.AclUtil.hasCreateAccess(acls, Consts.Acl.Activities._Site.Mod4);
			});

		this.RefreshContract();
		this.RefreshFinancials();
	}

	RefreshContract() {
		this.sharedData.RefreshContract(this.contractID)
			.then(() => {
				if (this.sharedData.contract.charDataCollection != null) {
					if (this.sharedData.contract.charDataCollection.status.lockIndicator == 0) {
						this.locked = false;
					}
					else {
						this.locked = true;
					}
				}
			});
	}

    RefreshFinancials(): ng.IPromise<any> {
        this.notifyService.startProgress();        
        return this.contractService.getFinancials(
            this.contractID)
        	.then((result) => {
                this.financialItemRows = result;
                this.financialItemRowsDisplay = this.financialItemRows.slice((this.amountPage - 1) * this.amountRowCount, ((this.amountPage - 1) * this.amountRowCount) + this.amountRowCount)
                this.amountNumFound = this.financialItemRows.length;
                this.amountPageCount = Math.ceil(this.amountNumFound / this.amountRowCount);
        		this.initialized = true;
        	})
        	.finally(() => {
        		this.notifyService.endProgress();
        	});
    }
    UpdateFinancialsDisplay() {
        this.financialItemRowsDisplay = this.financialItemRows.slice((this.amountPage - 1) * this.amountRowCount, ((this.amountPage - 1) * this.amountRowCount) + this.amountRowCount)
    }

	Delete() {

		if (this.$window.confirm("Are you sure you want to delete this Deal?") && this.$window.confirm("Are you REALLY SURE you want to delete this Deal?")) {
			this.notifyService.startProgress();
			this.contractService.deleteContract(this.contractID)
				.then(() => {
					this.$window.location.assign(Consts.Urls.ContractListPage);
				},
				() => {
					this.notifyService.notifyError("Error Deleting Deal");
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		} else {
			this.notifyService.broadcastDone();
		}
	}

	CopySuccessful(newEntityID: string) {
		//copy succeeded, navigate user to new entity
		this.$window.location.assign("/Go/" + newEntityID);
	}

	PreviewAccountingEntity(entityID: string) {
		this.selectedEntityID = entityID;
		this.$rootScope.$broadcast(Consts.Events.ViewEntity, entityID);
	}
}



export interface IRLDocumentDetailControllerScope extends IRLFilepickerScope {
	pickedFile: IFilestackPickFile;
}

export class DocumentDetailController extends RecordDetailController {
	static $inject = ["docScope", "entityService", "notifyService", "documentService", "$q", "invWindow", "entityConfigService", "eventService", "contactService"];
	recID: number;
	selectedFileName: string;
	parentTitle: string;
	listUrl: string;

	constructor(private docScope: IRLDocumentDetailControllerScope, private invEntityService: EntityService, private invNotifyService: NotifyService,
		private documentService: DocGenService, private $q: ng.IQService, private invWindow: ng.IWindowService, private invEntityConfigService: EntityConfigService,
		private invEventService: EventService, contactService: ContactService) {
		super(docScope, invEntityService, invNotifyService, invEventService, contactService, invEntityConfigService, invWindow);
		this.recID = 0;
		this.selectedFileName = "";
		this.listUrl = "";

		this.docScope.$watch(() => this.docScope.pickedFile,
			(newValue: IFilestackPickFile, oldValue: IFilestackPickFile) => {
				if (newValue != oldValue && newValue != null) {
					this.selectedFileName = newValue[0].filename;
					invNotifyService.notifySuccess("Document Uploaded");
					if (_.isNull(this.entityCharDataCollection.charDatas["entity_title"][0].value)) {
						this.selectedFileName = newValue[0].filename;

					}
				}
			}, true);
	}


	InitDetails(entityID: string, listUrl: string) {
		this.entityID = entityID;
		this.recID = Utils.IdBuilder.splitEntityID(entityID).recID;
		this.LoadEntity();
		this.listUrl = listUrl;
	}


	//save 
	SaveEntity(): ng.IPromise<any> {
		return this.$q.all([]);
	}

	Delete() {
		if (this.invWindow.confirm("Are you sure you want to delete this Document?")) {
			this.invNotifyService.startProgress();
			this.invEntityService.deleteEntity(this.entityID)
				.then(() => {
					this.invNotifyService.notifySuccess("Document has been deleted.");
					this.invWindow.location.assign(this.listUrl);
				},
				() => { this.invNotifyService.notifyError("There was a problem deleting this Document."); })
				.finally(() => {
					this.invNotifyService.endProgress();
				});
		} else {
			this.docScope.$broadcast(Consts.Events.NotifyDone);
		}
	}

	Cancel() {
		this.invNotifyService.startProgress();
		this.LoadEntity()
			.then(() => {
				this.editMode = false;
			})
			.finally(() => {
				this.invNotifyService.endProgress();
			});
	}
}

export class ContractEntityAssociationSearchController extends BaseEntityAssociationController {
	static $inject = ["$scope", "$location", "$filter", "notifyService", "$window", "$q",
		"eventService", "entityService", "entityConfigService", "adminService", "$interval", "searchService", "contractSharedDataService", "aclService", "contractService"];

	//Search objects
	keywords: string;
	pages: { [key: number]: number };
	templates: { [key: string]: Models.IKeyValuePair<string, number>[] };
	sortDirs: { [key: number]: string };
	sortFields: { [key: number]: string };
	selectedCharType: Models.IAssociationCharTypeAndTemplateGroupExtended;
	selectedTemplate: string;
	selectedStatus: string;
	searchStates: { [key: string]: Models.IAdvancedSearchModel };
	templateFacets: Models.IKeyValuePair<string, string>[];
	statusFacets: Models.IKeyValuePair<string, string>[];

	//Associations objects
	sharedData: ContractSharedDataService;
	filterByEntityID: string;
	charTypesAndTemplateGroups: Models.IAssociationCharTypeAndTemplateGroupExtended[];
	selectedRecords: any[];
	associateCharType: Models.IAssociationCharTypeAndTemplateGroupExtended;
	locked: boolean;
	currentCharTypeAndTemplateGroup: Models.IAssociationCharTypeAndTemplateGroupExtended;
    canCreate: boolean = false;
    canEdit: boolean = false;
	currentCharTypeName: string;
	refreshAssociationPanels: boolean;
	canCopy: boolean;
	initialized: boolean;

	constructor(private $scope: ng.IScope,
		private $location: ng.ILocationService, private $filter: ng.IFilterService,
		public notifyService: NotifyService, private $window: ng.IWindowService,
		public $q: ng.IQService,
		private eventService: EventService,
		private entityService: EntityService,
		private entityConfigService: EntityConfigService,
		public adminService: AdminService,
		public $interval: ng.IIntervalService,
		private searchService: SearchService,
		private contractSharedDataService: ContractSharedDataService,
		private aclService: AclService,
		private contractService: ContractService) {

		super($scope, notifyService, adminService, $interval, $q, entityService, eventService);

		//Search objects
		this.keywords = "";
		this.pages = {};
		this.templates = {};
		this.sortDirs = {};
		this.sortFields = {};
		this.selectedCharType = null;
		this.selectedTemplate = null;
		this.searchStates = {};
		this.templateFacets = [];
		this.statusFacets = [];

		//Associations objects
		this.sharedData = contractSharedDataService;
		this.filterByEntityID = "";
		this.charTypesAndTemplateGroups = [];
		this.selectedRecords = [];
		this.locked = false;
		this.currentCharTypeAndTemplateGroup = { name: "", createName: "", charTypeID: 0, tgIDs: [], isParentChar: false };
		this.currentCharTypeName = "";
		this.refreshAssociationPanels = false;
		this.canCopy = false;
		this.initialized = false;

		$scope.$watch(
			() => this.sharedData.contract != null ? this.sharedData.contract.charDataCollection.status.lockIndicator : 1,
			(newValue, oldValue) => {
				this.locked = newValue > 0;
			});

		this.$scope.$watch(() => {
			if (this.filterByEntityID == null) {
				return null;
			} else {
				return this.filterByEntityID;
			}
		},
			(newValue, oldValue) => {
				if (newValue != null) {
					this.eventService.on(Consts.Events.WorkflowExecuted + newValue, () => {
						return this.sharedData.RefreshContract(this.filterByEntityID);
					});
				}
			});
	}

	CharTypeChanged() {
		this.selectedTemplate = null;
		this.selectedStatus = null;
		this.BuildSearchStates();
	}

	TemplateChanged() {
		this.selectedStatus = null;
		this.BuildSearchStates();
	}

	StatusChanged() {
		this.BuildSearchStates();
	}

    Init(filterByEntityID: string, charTypeName: string, charTypeID: string, templateID: string) {
        this.filterByEntityID = filterByEntityID;

        //Get ACLs for user
        this.entityService.getEntityRecord(filterByEntityID)
            .then((result) => {
                var targetACL = Utils.AclUtil.getDataEntityAcl(result.charTypeID, result.templateGroupID, result.templateID);
                this.canCreate = Utils.AclUtil.hasCreateAccess(this.aclService.acls, targetACL);
                this.canEdit = Utils.AclUtil.hasWriteAccess(this.aclService.acls, targetACL);
            });

		this.aclService.loadActivityAcls()
			.then((acls) => {
				this.canCopy = Utils.AclUtil.hasCreateAccess(acls, Consts.Acl.Activities._Site.Mod4);
			});

		this.currentCharTypeName = charTypeName;
		this.LoadTemplateGroups();
		this.sharedData.RefreshContract(filterByEntityID);
		this.sharedData.RefreshContractStatus(filterByEntityID)
			.then(() => {
				this.initialized = true;
			});
	}

	RefreshValidation(): ng.IPromise<any> {
		this.refreshAssociationPanels = true;
		return this.eventService.call(Consts.Events.ValidateEntity);
	}

	LoadTemplateGroups() {
		this.notifyService.startProgress();

		//Hardcoded list of valid char types per Joe N.
		//16, 1, 17, 4, 15, and 7
		var validCharTypes = [16, 1, 4, 17, 15, 7, 99];

		this.entityConfigService.getRelatedConfigurationCharacteristicTypes(Consts.CharTypeIDs.transaction)
			.then((results) => {

				_.forEach(results, (result) => {
					var charName = result.charTypeName;

					if (charName == "Transaction") {
						charName = "Deals";
					}
					else if (charName == "Work Orders") {
						charName = "Jobs";
					}
					else if (charName == "Property") {
						charName = "Catalog Items";
					}
					else if (charName == "Invoice") {
						charName = "Accounting";
					}

					if (validCharTypes.indexOf(result.charTypeID) > -1) {
						this.charTypesAndTemplateGroups.push({
							name: charName,
							createName: charName,
							charTypeID: result.charTypeID,
							tgIDs: [1],
							isParentChar: false
						});

						if (this.currentCharTypeName == charName) {
							this.currentCharTypeAndTemplateGroup = {
								name: charName,
								createName: charName,
								charTypeID: result.charTypeID,
								tgIDs: [],
								isParentChar: false
							}
						}
					}
				});
			})
			.finally(() => {
				this.entityConfigService.getRelatedConfigurationParentCharacteristicTypes(Consts.CharTypeIDs.transaction)
					.then((results) => {
						_.forEach(results, (result) => {
							var charName = result.charTypeName;

							if (charName == "Transaction") {
								charName = "Deals";
							}
							else if (charName == "Work Orders") {
								charName = "Jobs";
							}
							else if (charName == "Property") {
								charName = "Catalog Items";
							}
							else if (charName == "Invoice") {
								charName = "Accounting";
							}

							var charType = { name: charName, createName: charName, charTypeID: result.charTypeID, tgIDs: [1], isParentChar: true }

							//Check to see if the array already has reference to this charType.  If so, we just want to flip the isParentChar flag to true
							//If not, add the new charType

							var matchingCharTypes = this.charTypesAndTemplateGroups.filter(ct => ct.charTypeID == result.charTypeID);

							if (validCharTypes.indexOf(result.charTypeID) > -1) {
								if (matchingCharTypes.length > 0) {
									var index = this.charTypesAndTemplateGroups.indexOf(matchingCharTypes[0]);
									this.charTypesAndTemplateGroups[index].isParentChar = true;
								}
								else {
									this.charTypesAndTemplateGroups.push(charType);
								}

								if (this.currentCharTypeName == charName) {
									this.currentCharTypeAndTemplateGroup = {
										name: charName,
										createName: charName,
										charTypeID: result.charTypeID,
										tgIDs: [],
										isParentChar: true
									}
								}
							}
						});
					})
					.finally(() => {
						//Sort the list based on how Joe wants it
						//Projects, Catalog Items, Deals, Inventory, Jobs, Accounting
						var sortList = [16, 1, 4, 17, 15, 7];

						var sorted = _.sortBy(this.charTypesAndTemplateGroups, function (obj) {
							return _.indexOf(sortList, obj.charTypeID);
						});

						var currentCharTypeIndex = _.findIndex(sorted, c => c.charTypeID == this.currentCharTypeAndTemplateGroup.charTypeID);

						this.SortByIndex(sorted, currentCharTypeIndex, 0);

						this.charTypesAndTemplateGroups = sorted;

						this.BuildSearchStates();
						this.notifyService.endProgress();
					});
			});
	}

	SortByIndex(collection: any[], fromIndex: number, toIndex: number) {
		collection.splice(toIndex, 0, collection.splice(fromIndex, 1)[0]);
	}

	SearchSubmit() {
		this.BuildSearchStates();
	}

	BuildSearchStates() {
		var tempSearchStates: { [key: string]: Models.IAdvancedSearchModel } = {};
		this.searchStates = {};

		var selectedCharTypeID = null;

		if (this.selectedCharType != null) {
			selectedCharTypeID = this.selectedCharType.charTypeID;
		}

		//associations
		var metaDataSearchRequest: Models.IAdvancedSearchModel = {
			charTypeID: selectedCharTypeID,
			searchGroups: [],
			keywords: this.keywords,
			page: this.pages[selectedCharTypeID] || 1,
			rowCount: 10,
			templateGroupIDs: [1, 2],
			template: this.selectedTemplate,
			status: this.selectedStatus,
			sortDir: _.parseInt(this.sortDirs[selectedCharTypeID]) || 1,
			sortField: this.sortFields[selectedCharTypeID] || "",
			relatedEntityID: this.filterByEntityID
		};

		this.searchService.advancedSearch(metaDataSearchRequest)
			.then((res) => {
				this.templateFacets = res.getTemplateFacets();
				this.statusFacets = res.getStatusFacets();
			});
		// end reflective association search

		if (this.selectedCharType != null) {
			var searchState: Models.IAdvancedSearchModel = {
				charTypeID: selectedCharTypeID,
				searchGroups: [],
				keywords: this.keywords,
				page: this.pages[selectedCharTypeID] || 1,
				rowCount: 10,
				templateGroupIDs: [1, 2],
				template: this.selectedTemplate,
				status: this.selectedStatus,
				sortDir: _.parseInt(this.sortDirs[selectedCharTypeID]) || 1,
				sortField: this.sortFields[selectedCharTypeID] || "",
				relatedEntityID: this.filterByEntityID,
				explicitRelationshipsOnly: true
			};

			tempSearchStates[this.selectedCharType.name] = searchState;
		}
		else {
			_.each(this.charTypesAndTemplateGroups, ct => {
				var searchState: Models.IAdvancedSearchModel = {
					charTypeID: ct.charTypeID,
					searchGroups: [],
					keywords: this.keywords,
					page: this.pages[selectedCharTypeID] || 1,
					rowCount: 10,
					templateGroupIDs: [1, 2],
					template: this.selectedTemplate,
					status: this.selectedStatus,
					sortDir: _.parseInt(this.sortDirs[selectedCharTypeID]) || 1,
					sortField: this.sortFields[selectedCharTypeID] || "",
					relatedEntityID: this.filterByEntityID,
					explicitRelationshipsOnly: true
				};

				tempSearchStates[ct.name] = searchState;
			});
		}

		var keys = _.keys(tempSearchStates);
		keys.forEach(k => {
			var searchState = tempSearchStates[k];
			if (searchState.charTypeID == this.currentCharTypeAndTemplateGroup.charTypeID) {
				searchState.filterByEntityID = this.filterByEntityID;
				searchState.keywords = this.filterByEntityID;
				searchState.relatedEntityID = "";
			}
		});

		this.searchStates = tempSearchStates;
	}

	ClearSearch($event?: ng.IAngularEvent) {
		if ($event != null) {
			$event.preventDefault();
		}
		this.keywords = "";
		this.BuildSearchStates();
	}

	CopySuccessful(newEntityID: string) {
		//copy succeeded, navigate user to new entity
		this.$window.location.assign("/Go/" + newEntityID);
	}

	Delete() {

		if (this.$window.confirm("Are you sure you want to delete this Deal?") && this.$window.confirm("Are you REALLY SURE you want to delete this Deal?")) {
			this.notifyService.startProgress();
			this.contractService.deleteContract(this.filterByEntityID)
				.then(() => {
					this.$window.location.assign(Consts.Urls.ContractListPage);
				},
				() => {
					this.notifyService.notifyError("Error Deleting Deal");
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		} else {
			this.notifyService.broadcastDone();
		}
	}

	ViewEntity(viewEntityID: string) {
		this.entityService.getEntity(viewEntityID)
			.then((res) => {
				this.selectedEntity = res;
			});
	}
}
